import GestureOutlinedIcon from '@mui/icons-material/GestureOutlined';

/**
 * Quantificação de estrias: quantidade e eritema por região do corpo.
 * Referência clínica: estrias com eritema são as estrias rubras (fase inicial,
 * inflamatória, mais responsivas ao tratamento); sem eritema são as estrias
 * albas (fase madura, atrófica e esbranquiçada). Fonte: StatPearls, "Striae
 * Distensae" (NCBI Bookshelf). Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/stretch_marks.php.
 */
const stretchMarks = {
  key: 'stretch_marks',
  name: 'Quantificação de estrias',
  description: 'Quantidade e eritema das estrias por região',
  details: 'Registra, em cada região (abdome, mamas, membros inferiores, glúteos e quadril), quantas estrias existem e quanto eritema elas têm. Estrias avermelhadas estão na fase inicial (rubras) e costumam responder melhor ao tratamento; sem eritema, são estrias maduras e esbranquiçadas (albas). Marque só as regiões avaliadas: o card mostra o registro da última consulta e a aba Saúde guarda a evolução.',
  kind: 'regions',
  icon: GestureOutlinedIcon,
  accent: 'pink',
  regions: [
    { key: 'abdomen', label: 'Abdome' },
    { key: 'breasts', label: 'Mamas' },
    { key: 'lower_limbs', label: 'Membros inferiores' },
    { key: 'glutes_hips', label: 'Glúteos e quadril' },
  ],
  columns: [
    {
      key: 'amount',
      label: 'Quantidade',
      options: [
        { value: 'few', label: 'Poucas' },
        { value: 'moderate', label: 'Moderadas' },
        { value: 'many', label: 'Muitas' },
      ],
    },
    {
      key: 'erythema',
      label: 'Eritema',
      options: [
        { value: 'none', label: 'Sem' },
        { value: 'mild', label: 'Leve' },
        { value: 'intense', label: 'Intenso' },
      ],
    },
  ],
};

export default stretchMarks;
